const getStyles = (theme) => ({
  loaderContainer: {
    height: 'calc(100vh - 10rem)'
  }

});

export default getStyles;